import Stack from 'components/atoms/stack/Stack'
import React, { useState } from "react";
import { Children, cloneElement, isValidElement } from 'react';
import { View } from 'react-native';
import { layoutStyles } from 'styles/layout';

const HStack = ({ children, ...props }) => {

	const justifyContent = props?.style?.justifyContent ?? 'space-evenly';

	const updatedChildren = Children.map(children, child => {
		if ( isValidElement(child) && justifyContent === 'space-evenly' ) {
			return (
				<View
					style={[ layoutStyles.flexOne, props.itemStyle ?? {} ]}>

					{ child }
				</View>
			)
		}

		return child;
	});
	
	return (
		<Stack
			{ ...props }
			direction="row"
			style={[
				props.style ?? {},
				{
					justifyContent: justifyContent,
				},
			]}>
			
			{ updatedChildren }
		</Stack>
	)
}

export default HStack;
